namespace $ {

	export class $shm_projects_data_cache extends $mol_object2 {

		static key( api: string, identity: string ) {
			// A fingerprint namespaces the cache without persisting URLs or credentials.
			const hash = this.$.$mol_crypto2_hash( new TextEncoder().encode( JSON.stringify([ api, identity ]) ) )
			return '$shm_projects_summaries:v1:' + Array.from( hash, byte => byte.toString( 16 ).padStart( 2, '0' ) ).join( '' )
		}

		static normalize( response: unknown ): readonly $shm_projects_api_project_summary[] {
			if( !Array.isArray( response ) ) throw new Error( 'Project summaries response must be an array' )
			const ids = new Set<string>()
			return response.map( project => {
				if( !project || typeof project.id !== 'string' || !project.id || typeof project.title !== 'string' || !project.title ) {
					throw new Error( 'Project summary id and title are required' )
				}
				if( ids.has( project.id ) ) throw new Error( `Duplicate project summary id: ${ project.id }` )
				ids.add( project.id )
				return this.$.$shm_projects_api_project_summary({
					...project,
					channels: project.channels ? {
						...( typeof project.channels.prerelease === 'string' ? { prerelease: project.channels.prerelease } : {} ),
						...( typeof project.channels.release === 'string' ? { release: project.channels.release } : {} ),
					} : undefined,
				})
			} )
		}

		static read( key: string ): readonly $shm_projects_api_project_summary[] | null {
			// This is a persistence snapshot, not a second reactive source. The request
			// channel wakes its consumers when the background response becomes ready.
			return this.$.$mol_error_fence(
				()=> {
					const raw = this.$.$mol_state_local.native().getItem( key )
					return raw === null || raw === undefined ? null : this.normalize( JSON.parse( raw ) )
				},
				()=> null,
				promise => this.$.$mol_fail_hidden( promise ),
			)
		}

		static write( key: string, summaries: readonly $shm_projects_api_project_summary[] ) {
			const clean = this.normalize( summaries )
			return this.$.$mol_error_fence(
				()=> {
					const storage = this.$.$mol_state_local.native()
					const raw = JSON.stringify( clean )
					if( storage.getItem( key ) !== raw ) storage.setItem( key, raw )
					return clean
				},
				()=> clean, // Storage quota/privacy settings must not break the list.
				promise => this.$.$mol_fail_hidden( promise ),
			)
		}
	}
}
